import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategoryTranslationLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 33 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#category_translation_large_icon_svg__a)"
            fill="#404145">
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M1.651 1.319A3.364 3.364 0 0 1 4.03.333h11.272a3.364 3.364 0 0 1 3.364 3.364V9h-2V3.697a1.364 1.364 0 0 0-1.364-1.364H4.03a1.364 1.364 0 0 0-1.364 1.364v9.939A1.364 1.364 0 0 0 4.03 15h1.303v1.798L8.03 15H12v2H8.634l-5.302 3.535v-3.608a3.363 3.363 0 0 1-2.667-3.291V3.697c0-.892.354-1.748.985-2.378Z"/>
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M17.267 11H28.75a3.37 3.37 0 0 1 3.25 3.459v9.749a3.37 3.37 0 0 1-2.666 3.386v3.608l-5.303-3.535h-6.763l-.017-.001A3.37 3.37 0 0 1 14 24.208v-9.75a3.37 3.37 0 0 1 3.25-3.457l.017-.001Zm11.427 14.667A1.37 1.37 0 0 0 30 24.255v-9.843A1.37 1.37 0 0 0 28.694 13h-11.39A1.369 1.369 0 0 0 16 14.412v9.843a1.37 1.37 0 0 0 1.306 1.412h7.33l2.698 1.798v-1.798h1.361Z"/>
            <path d="M14.557 5.43c-.411-.037-.775-.055-1.334-.055a7.364 7.364 0 0 1-.634 1.802 6.883 6.883 0 0 1-1.036 1.512 8.99 8.99 0 0 0 3.2 1.131 5.99 5.99 0 0 0-.924 1.717 11.522 11.522 0 0 1-3.55-1.7 11.989 11.989 0 0 1-3.716 1.72 5.42 5.42 0 0 0-.897-1.653A10.185 10.185 0 0 0 8.981 8.68a8.168 8.168 0 0 1-1.2-1.708 8.247 8.247 0 0 1-.644-1.6c-.551 0-.87.019-1.334.056V3.74c.45.048.903.07 1.355.065h2.056v-.56a2.742 2.742 0 0 0-.056-.578h1.877a2.88 2.88 0 0 0-.056.569v.57h2.223c.453.004.905-.017 1.355-.066v1.69Zm-5.632-.055c.241.852.69 1.63 1.308 2.266a5.28 5.28 0 0 0 1.166-2.266H8.925ZM24.825 23.268l-.423-1.6h-2.783l-.433 1.6h-2.543l2.795-8.601h3.088l2.83 8.601h-2.531Zm-.903-3.504-.37-1.405a32.922 32.922 0 0 1-.313-1.214c-.12-.496-.2-.851-.242-1.066a24.84 24.84 0 0 1-.208.984c-.103.45-.334 1.357-.69 2.701h1.823Z"/>
        </g>
        <defs>
            <clipPath id="category_translation_large_icon_svg__a">
                <path fill="#fff"
                    transform="translate(.332)"
                    d="M0 0h32v32H0z"/>
            </clipPath>
        </defs>
    </svg>
);
CategoryTranslationLargeIcon.displayName = 'CategoryTranslationLargeIcon';
export default CategoryTranslationLargeIcon;
